import React from 'react'
import { LandingPage as LayerLandingPage } from '@layerfi/components'

export const MyLandingPage = () => {
  return (
    <LayerLandingPage
      availableOffers={['accounting', 'bookkeeping']}
      platform={{ industry: 'Freelancing', platformName: 'Moxie' }}
      heroOverrides={{
        stringOverrides: {
          // heading1: 'Hero Heading 1',
          // heading1Desc: 'Hero Heading 1 Description',
          // heading2: 'Hero Heading 2',
          // heading2Desc: 'Hero Heading 2 Description',
          // subtitle: 'Hero Subtitle',
          // title: 'Hero Title',
        },
        cta: {
          primary: {
            label: 'Book a call',
            url: 'https://calendly.com/darren-layerfi/accounting-setup-onboarding',
          },
          secondary: {
            label: 'Learn More',
            url: 'https://www.layerfi.com/product',
          },
        },
        // mediaUrls: {
        //   topOfFoldImage: 'https://picsum.photos/200/300',
        // }
      }}
      offeringOverrides={{
        // stringOverrides: {
        //   sectionTitle: 'Service Offering Title',
        // },
        // Accounting configuration overrides
        accounting: {
          stringOverrides: {
            // badge: 'Badge Label',
            // priceAmount: '$100',
            // priceUnit: '/month',
            // subtitle: 'Accounting Subtitle',
            // title: 'Accounting Title',
          },
          cta: {
            primary: {
              label: 'Book a call',
              url: 'https://calendly.com/darren-layerfi/accounting-setup-onboarding',
            },
          },
        },
        // Bookkeeping configuration overrides
        bookkeeping: {
          stringOverrides: {
            // badge: 'Badge Label',
            // priceAmount: '$100',
            // priceUnit: '/month',
            // subtitle: 'Bookkeeping Subtitle',
            // title: 'Bookkeeping Title',
          },
          cta: {
            primary: {
              label: 'Book a call',
              url: 'https://calendly.com/darren-layerfi/accounting-setup-onboarding',
            },
          },
        },
      }}
    />
  )
}
